exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mt-info a {\r\n    font-size: 45px;\r\n    color: #FFFFFF;\r\n    transition: linear 0.1s;\r\n    line-height: 50px;\r\n}\r\n\r\n    .mt-info a:hover {\r\n        color: #FC6119;\r\n        transition: linear 0.1s;\r\n    }\r\n\r\n.badge-green,\r\n.label-green,\r\n.green {\r\n    background-color: #018E42 !important;\r\n}\r\n\r\n.badge-yellow,\r\n.label-yellow,\r\n.yellow {\r\n    background-color: #F1C40F !important;\r\n}\r\n\r\n.badge-red,\r\n.label-red,\r\n.red {\r\n    background-color: #BF1A2F !important;\r\n}\r\n\r\n.badge-blue,\r\n.label-blue,\r\n.blue {\r\n    background-color: #2F4F7C !important;\r\n}\r\n\r\na.btn, \r\nlabel.btn {\r\n    border: none !important;\r\n}\r\n\r\nlabel.btn,\r\nlabel.btn:hover {\r\n    transition: linear 0.05s;\r\n}\r\n\r\nlabel.btn:hover,\r\nlabel.btn.active {\r\n    transform: scale(1.05, 1.05);\r\n    background-color: #FC6119 !important;\r\n}\r\n\r\ndiv.description {\r\n    text-align: center;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/adminuser/profile/adminuser-profile.component.css
// module id = 973
// module chunks = 1